// extracted by mini-css-extract-plugin
export var notificationHost = "_l0-0";